import TabContext from "@mui/lab/TabContext";

import TabPanel from "./TabPanel";

export { TabContext, TabPanel };
